import Base64Image from 'component/Base64Image'
import styled from 'styled-components'
import themeAssetloadingQuickAccessSvg from '@theme/loading/quick-access.svg'

export const Wrapper = styled.div<{ autoWidth?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 0.35897rem;
  color: var(--shortcut-color, #fff);
  cursor: pointer;
  user-select: none;
  width: ${(props) => (props?.autoWidth ? 'auto' : '1.6rem')};
`

export const ShortcutImage = styled(Base64Image).attrs(({ width, ...props }) => {
  return {
    ...props,
    placeholder: themeAssetloadingQuickAccessSvg,
    aspectRatio: 1,
    source: 'picture',
    style: {
      width: width || '1.6rem',
    },
  }
})`
  border-radius: 50%;
  margin-bottom: 16px;
`

export const ShortcutName = styled.div`
  position: relative;
  white-space: nowrap;
  // 文字可能重疊，規格表明設定最多5個字避免重疊
  /* overflow-x: visible; */
  /* overflow-y: hidden; */
  width: fit-content;
  width: 100%;
  min-height: 0.4rem;

  ::-webkit-scrollbar {
    width: 0.026rem;
    cursor: pointer;
  }
  /* scroll bar 底部背景 */
  ::-webkit-scrollbar-track {
    background: transparent;
    cursor: pointer;
  }

  /* scroll bar 滑動本身 */
  ::-webkit-scrollbar-thumb {
    //background: #c238dc;
    cursor: pointer;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    //background: #9B23AA;
    cursor: pointer;
  }
`

export const ShortcutNameText = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  /* 破版兜底：限制最大顯示寬度（約 5 個中文字寬），避免超寬英數溢出重疊相鄰入口。
     不使用省略號（text-overflow: clip）；realistic 內容落在此範圍內完整顯示，僅病態寬字被裁切。
     5.2em 由瀏覽器實測定稿：安全區間 [5.001em(不裁5漢字), 5.336em(最緊 template 6 不重疊)]，取中段。 */
  max-width: 5.2em;
  overflow: hidden;
  text-overflow: clip;
  white-space: nowrap;
  text-align: center;
`
